<template>
  <v-container
    fluid
    grid-list-md
    pt-2
    class="expandable-height-container grey lighten-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'pl-0': $vuetify.breakpoint.width > 1600 }"
  >
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  name: 'AbfContainer'
};
</script>

<style>
.expandable-height-container {
  height: calc(100vh - 130px);
  max-height: calc(100vh - 130px);
  overflow-y: auto;
}
</style>
